import { useState, useRef } from "react";
import { Upload, Loader2, X } from "lucide-react";
import api, { resolveImg } from "@/lib/api";
import { toast } from "sonner";

const ImageUpload = ({ value, onChange, label = "Gambar", testid = "image", hint, contain = false }) => {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef();

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/upload", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.url);
      toast.success("Gambar berhasil diunggah");
    } catch (err) {
      toast.error("Gagal mengunggah gambar");
    } finally {
      setUploading(false);
      if (e.target) e.target.value = "";
    }
  };

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-slate-700">{label}</label>
      {hint && <p className="text-xs text-slate-400">{hint}</p>}
      <div className="flex items-start gap-4">
        {value ? (
          <div className="relative">
            <img src={resolveImg(value)} alt="preview" className={`h-24 w-24 rounded-lg border ${contain ? "bg-white object-contain p-1" : "object-cover"}`} data-testid={`${testid}-preview`} />
            <button
              type="button"
              onClick={() => onChange("")}
              data-testid={`${testid}-remove`}
              className="absolute -right-2 -top-2 rounded-full bg-red-500 p-1 text-white shadow"
            >
              <X className="h-3 w-3" />
            </button>
          </div>
        ) : (
          <div className="flex h-24 w-24 items-center justify-center rounded-lg border-2 border-dashed border-slate-300 bg-slate-50 text-slate-400">
            <Upload className="h-6 w-6" />
          </div>
        )}
        <div className="flex-1 space-y-2">
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            disabled={uploading}
            data-testid={`${testid}-upload-button`}
            className="inline-flex items-center gap-2 rounded-lg border border-emerald-200 bg-white px-4 py-2 text-sm font-medium text-emerald-700 hover:bg-emerald-50 disabled:opacity-60"
          >
            {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
            {uploading ? "Mengunggah..." : "Pilih Gambar"}
          </button>
          <input
            type="text"
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder="atau tempel URL gambar"
            data-testid={`${testid}-url-input`}
            className="w-full rounded-lg border border-slate-200 px-3 py-1.5 text-xs text-slate-600"
          />
        </div>
        <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} className="hidden" />
      </div>
    </div>
  );
};

export default ImageUpload;
